interface BulkDeleteModalProps {
  isOpen: boolean
  count: number
  onConfirm: () => void
  onCancel: () => void
  isDeleting?: boolean
}

export function BulkDeleteModal({
  isOpen,
  count,
  onConfirm,
  onCancel,
  isDeleting = false,
}: BulkDeleteModalProps) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4 lightbox-enter">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-6 lightbox-image-enter">
        {/* Warning icon */}
        <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4">
          <span className="material-symbols-outlined text-2xl text-red-600">warning</span>
        </div>

        {/* Title */}
        <h3 className="text-lg font-semibold text-text-main text-center mb-2">
          Delete {count} generation{count !== 1 ? 's' : ''}?
        </h3>

        {/* Description */}
        <p className="text-sm text-text-muted text-center mb-6">
          This will permanently delete {count === 1 ? 'this generation' : 'these generations'} and all {count === 1 ? 'its' : 'their'} images. This action cannot be undone.
        </p>

        {/* Actions */}
        <div className="flex gap-3">
          <button
            onClick={onCancel}
            disabled={isDeleting}
            className="flex-1 px-4 py-2.5 rounded-xl border border-border-color text-text-main font-medium hover:bg-surface-muted transition-colors disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isDeleting}
            className="flex-1 px-4 py-2.5 rounded-xl bg-red-600 text-white font-medium hover:bg-red-700 transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
          >
            {isDeleting ? (
              <>
                <div className="w-4 h-4 border-2 border-white/20 border-t-white rounded-full animate-spin" />
                Deleting...
              </>
            ) : (
              <>
                <span className="material-symbols-outlined text-sm">delete</span>
                Delete
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  )
}
